/**
 * VENTARA — Wordmark.
 *
 * Custom lettering built from the real Geist Regular glyph outlines
 * (extracted directly from the font file), not the live font, so we can
 * carry two deliberate cuts: the E's vertical stem is removed (three
 * floating bars) and both A's crossbars are removed (open, pointed
 * triangles) — everything else (V, N, T, R) is the unmodified glyph
 * shape. Renders in `currentColor`, so it follows the same text-color
 * classes the plain-text version used to.
 */
export default function VentaraWordmark({ className = "", height = 15, title = "Ventara" }) {
    const viewW = 5533;
    const viewH = 710;
    const width = height * (viewW / viewH);

    return (
        <svg
            viewBox={`0 0 ${viewW} ${viewH}`}
            width={width}
            height={height}
            className={className}
            fill="currentColor"
            role="img"
            aria-label={title}
        >
            <g transform="translate(0,710) scale(1,-1)">
                {/* V */}
                <path fillRule="evenodd" d="M277 0 20 710H114L334 94L553 710H647L390 0Z" />
                {/* E — stem removed, three floating bars */}
                <g transform="translate(827,0)">
                    <path fillRule="evenodd" d="M92 626L92 710L538 710L538 626Z M92 315L92 397L526 397L526 315Z M92 0L92 84L546 84L546 0Z" />
                </g>
                {/* N */}
                <g transform="translate(1590,0)">
                    <path fillRule="evenodd" d="M92 0V710H214L565 86V710H651V0H523L178 612V0Z" />
                </g>
                {/* T */}
                <g transform="translate(2493,0)">
                    <path fillRule="evenodd" d="M233 0V626H12V710H540V626H319V0Z" />
                </g>
                {/* A — crossbar removed, open triangle */}
                <g transform="translate(3205,0)">
                    <path fillRule="evenodd" d="M20 0L276 710L392 710L648 0L554 0L483 202L185 202L114 0Z M185 202L483 202L334 635Z" />
                </g>
                {/* R */}
                <g transform="translate(4033,0)">
                    <path fillRule="evenodd" d="M92 0V710H361Q436 710 490.0 684.0Q544 658 573.5 609.5Q603 561 603 495Q603 447 580.5 409.5Q558 372 523.0 350.0Q488 328 450 326L444 335Q509 335 546.5 305.0Q584 275 590 209L610 0H523L505 200Q501 244 473.5 265.0Q446 286 384 286H178V0ZM178 370H372Q437 370 475.0 403.0Q513 436 513 497Q513 559 474.0 592.5Q435 626 361 626H178Z" />
                </g>
                {/* A2 — crossbar removed, open triangle */}
                <g transform="translate(4865,0)">
                    <path fillRule="evenodd" d="M20 0L276 710L392 710L648 0L554 0L483 202L185 202L114 0Z M185 202L483 202L334 635Z" />
                </g>
            </g>
        </svg>
    );
}
